import request from "@/utils/request";

// // 设置数据
// localStorage.setItem('key', 'value');

// // 获取数据
// const value = localStorage.getItem('key');

// // 删除数据
// localStorage.removeItem('key');
// 登录
export function codelogin(data) {
    return request({
        url: "/api/codelogin",
        method: "post",
        data,
    });
}
// 上传文件
export function getupload(data) {
    return request({
        url: "/api/upload",
        method: "post",
        data,
    });
}

// 修改用户信息
export function useredit(data) {
    return request({
        url: "/api/useredit",
        method: "post",
        data,
    });
}

//创建项目
export function ainewProjectadd(data) {
    return request({
        url: "/api/ainewProjectadd",
        method: "post",
        data,
    });
}
//查询项目
export function ainewProjectlist(data) {
    return request({
        url: "/api/ainewProjectlist",
        method: "post",
        data,
    });
}
// 项目详情
export function ainewProjectinfo(data) {
    return request({
        url: "/api/ainewProjectinfo",
        method: "post",
        data,
    });
}

// 删除项目
export function ainewProjectremove(data) {
    return request({
        url: "/api/ainewProjectremove",
        method: "post",
        data,
    });
}

// 修改项目
export function ainewProjectedit(data) {
    return request({
        url: "/api/ainewProjectedit",
        method: "post",
        data,
    });
}

// 查询章节
export function ainewProjectChapterlist(data) {
    return request({
        url: "/api/ainewProjectChapterlist",
        method: "post",
        data,
    });
}

// 新增章节
export function ainewProjectChapteradd(data) {
    return request({
        url: "/api/ainewProjectChapteradd",
        method: "post",
        data,
    });
}
// 修改章节
export function ainewProjectChapteredit(data) {
    return request({
        url: "/api/ainewProjectChapteredit",
        method: "post",
        data,
    });
}

// 删除章节
export function ainewProjectChapterremove(data) {
    return request({
        url: "/api/ainewProjectChapterremove",
        method: "post",
        data,
    });
}
//  查询章节详情
export function ainewProjectChapterinfo(data) {
    return request({
        url: "/api/ainewProjectChapterinfo",
        method: "post",
        data,
    });
}

// 新增剧本
export function ainewChapterScriptadd(data) {
    return request({
        url: "/api/ainewChapterScriptadd",
        method: "post",
        data,
    });
}
// 查询剧本
export function ainewChapterScriptlist(data) {
    return request({
        url: "/api/ainewChapterScriptlist",
        method: "post",
        data,
    });
}

// 修改剧本
export function ainewChapterScriptedit(data) {
    return request({
        url: "/api/ainewChapterScriptedit",
        method: "post",
        data,
    });
}
// 查询风格分类
export function ainewStyleCategorylist(data) {
    return request({
        url: "/api/ainewStyleCategorylist",
        method: "post",
        data,
    });
}
// 查询风格
export function ainewPlatformStylelist(data) {
    return request({
        url: "/api/ainewPlatformStylelist",
        method: "post",
        data,
    });
}
// AI生成剧本
export function aitext(data) {
    return request({
        url: "/api/aitext",
        method: "post",
        data,
    });
}

// 获取音色数据
export function ainewTimbrelist(data) {
    return request({
        url: "/api/ainewTimbrelist",
        method: "post",
        data,
    });
}
//  主体提取剧本内容
export function aizhuti(data) {
    return request({
        url: "/api/aizhuti",
        method: "post",
        data,
    });
}

// 查询章节主体
export function ainewChapterSubjectlist(data) {
    return request({
        url: "/api/ainewChapterSubjectlist",
        method: "post",
        data,
    });
}


// 查询章节主体详情
export function ainewChapterSubjectinfo(data) {
    return request({
        url: "/api/ainewChapterSubjectinfo",
        method: "post",
        data,
    });
}
// 新增主体
export function ainewChapterSubjectadd(data) {
    return request({
        url: "/api/ainewChapterSubjectadd",
        method: "post",
        data,
    });
}

//修改主体
export function ainewChapterSubjectedit(data) {
    return request({
        url: "/api/ainewChapterSubjectedit",
        method: "post",
        data,
    });
}
//删除主体
export function ainewChapterSubjectremove(data) {
    return request({
        url: "/api/ainewChapterSubjectremove",
        method: "post",
        data,
    });
}
//查询ai 模型列表
export function ainewModellist(data) {
    return request({
        url: "/api/ainewModellist",
        method: "post",
        data,
    });
}
// 生成主体图
export function aiphoto(data) {
    return request({
        url: "/api/aiphoto",
        method: "post",
        data,
    });
}
//  ai 生成分镜数据
export function aifenjing(data) {
    return request({
        url: "/api/aifenjing",
        method: "post",
        data,
    });
}
// 查询分镜列表
export function ainewChapterStoryFenjinglist(data) {
    return request({
        url: "/api/ainewChapterStoryFenjinglist",
        method: "post",
        data,
    });
}
//分镜详情
export function ainewChapterStoryFenjinginfo(data) {
    return request({
        url: "/api/ainewChapterStoryFenjinginfo",
        method: "post",
        data,
    });
}

// 新增分镜列表
export function ainewChapterStoryFenjingadd(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingadd",
        method: "post",
        data,
    });
}

// 修改分镜
export function ainewChapterStoryFenjingedit(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingedit",
        method: "post",
        data,
    });
}
// 删除分镜
export function ainewChapterStoryFenjingremove(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingremove",
        method: "post",
        data,
    });
}

//分镜生成故事板
export function aifenjingmp3(data) {
    return request({
        url: "/api/aifenjingmp3",
        method: "post",
        data,
    });
}
// 修改分镜台词
export function ainewChapterStoryFenjingedittaici(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingedittaici",
        method: "post",
        data,
    });
}
// 试听
export function shiting(data) {
    return request({
        url: "/api/shiting",
        method: "post",
        data,
    });
}
// 分镜生成图片
export function aifenjingphoto(data) {
    return request({
        url: "/api/aifenjingphoto",
        method: "post",
        data,
    });
}
//故事板 新增视频参数
export function ainewChapterStoryFenjingVideoadd(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoadd",
        method: "post",
        data,
    });
}
//故事板 查询视频参数
export function ainewChapterStoryFenjingVideolist(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideolist",
        method: "post",
        data,
    });
}
//故事板 新增ai视频
export function aivideo(data) {
    return request({
        url: "/api/aivideo",
        method: "post",
        data,
    });
}
//故事板 查询视频详情
export function ainewChapterStoryFenjingVideoinfo(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoinfo",
        method: "post",
        data,
    });
}
//故事板 修改视频详情
export function ainewChapterStoryFenjingVideoedit(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoedit",
        method: "post",
        data,
    });
}

export function ainewChapterStoryFenjingVideoremove(data) {
    return request({
        url: "/api/ainewChapterStoryFenjingVideoremove",
        method: "post",
        data,
    });
}
//  故事板生成视频
export function getaivideo(data) {
    return request({
        url: "/api/aivideo",
        method: "post",
        data,
    });
}
// 查询章节 最后的成片
export function ainewChapterFinalVideolist(data) {
    return request({
        url: "/api/ainewChapterFinalVideolist",
        method: "post",
        data,
    });
}
// 新增章节 最后的成片
export function ainewChapterFinalVideoadd(data) {
    return request({
        url: "/api/ainewChapterFinalVideoadd",
        method: "post",
        data,
    });
}
// 修改章节 最后的成片
export function ainewChapterFinalVideoedit(data) {
    return request({
        url: "/api/ainewChapterFinalVideoedit",
        method: "post",
        data,
    });
}

//合并视频
export function hebingvideo(data) {
    return request({
        url: "/api/hebingvideo",
        method: "post",
        data,
    });
}

// 查询ai厂商
export function ainewModelVendorslist(data) {
    return request({
        url: "/api/ainewModelVendorslist",
        method: "post",
        data,
    });
}

//模型版本
export function ainewModelVersionslist(data) {
    return request({
        url: "/api/ainewModelVersionslist",
        method: "post",
        data,
    });
}
//模型规格
export function ainewOutputSpecslist(data) {
    return request({
        url: "/api/ainewOutputSpecslist",
        method: "post",
        data,
    });
}
//模型计费规格
export function ainewPricingRuleslist(data) {
    return request({
        url: "/api/ainewPricingRuleslist",
        method: "post",
        data,
    });
}
// 用户信息
export function userInfo(data) {
    return request({
        url: "/api/userInfo",
        method: "post",
        data,
    });
}

// 获取配置信息
export function ainewAiSettinginfo(data) {
    return request({
        url: "/api/ainewAiSettinginfo",
        method: "post",
        data,
    });
}
//  查询用户 邀请记录明细

export function daUserInviteDetaillist(data) {
    return request({
        url: "/api/daUserInviteDetaillist",
        method: "post",
        data,
    });
}
// 查询点数流水 变动
export function aiPointsFlowlist(data) {
    return request({
        url: "/api/aiPointsFlowlist",
        method: "post",
        data,
    });
}

// 查询用户余额明细
export function daUserBalanceDetaillist(data) {
    return request({
        url: "/api/daUserBalanceDetaillist",
        method: "post",
        data,
    });
}
// 获取会员卡
export function ainewMemberCardlist(data) {
    return request({
        url: "/api/ainewMemberCardlist",
        method: "post",
        data,
    });
}

// 使用卡密
export function useraiCard(data) {
    return request({
        url: "/api/useraiCard",
        method: "post",
        data,
    });
}

//查询充值算力列表
export function aiPointslist(data) {
    return request({
        url: "/api/aiPointslist",
        method: "post",
        data,
    });
}

// 支付接口
export function alipaywebpay(data) {
    return request({
        url: "/api/alipaywebpay",
        method: "post",
        data,
    });
}

// 注册登录相关接口////////
// 账号密码登录
export function h5login(data) {
    return request({
        url: "/api/h5login",
        method: "post",
        data,
    });
}
// 验证码登录
export function phonelogin(data) {
    return request({
        url: "/api/phonelogin",
        method: "post",
        data,
    });
}

// 忘记密码
export function findPassword(data) {
    return request({
        url: "/api/findPassword",
        method: "post",
        data,
    });
}
// 注册
export function registerUser(data) {
    return request({
        url: "/api/registerUser",
        method: "post",
        data,
    });
}

// 修改密码
export function changePassword(data) {
    return request({
        url: "/api/changePassword",
        method: "post",
        data,
    });
}

// 修改用户信息（昵称、头像等）
export function editUserInfo(data) {
    return request({
        url: "/api/editUserInfo",
        method: "post",
        data,
    });
}

// 发送验证码
export function aisendCode(data) {
    return request({
        url: "/api/aisendCode",
        method: "post",
        data,
    });
}

// 子账号 新增接口
export function subAccountCreate(data) {
    return request({
        url: "/api/team/subAccount/create",
        method: "post",
        data,
    });
}
// 子账号 查询接口
export function subAccountList(data) {
    return request({
        url: "/api/team/subAccount/list",
        method: "post",
        data,
    });
}

// 子账号修改接口
export function subAccountUpdate(data) {
    return request({
        url: "/api/team/subAccount/update",
        method: "post",
        data,
    });
}
// 子账号删除 接口  /api/team/subAccount/delete?id=1
export function subAccountDelete(data) {
    return request({
        url: "/api/team/subAccount/delete",
        method: "post",
        data,
    });
}


// 创建团队   /api/team/create
export function teamCreate(data) {
    return request({
        url: "/api/team/create",
        method: "post",
        data,
    });
}

// 查询团队  /api/team/myCreatedTeams
export function teamMyCreatedTeams(data) {
    return request({
        url: "/api/team/myCreatedTeams",
        method: "post",
        data,
    });
}

// 修改 团队  /api/team/update
export function teamUpdate(data) {
    return request({
        url: "/api/team/update",
        method: "post",
        data,
    });
}

// 解散团队 /api/team/dissolve?id=1
export function teamDissolve(data) {
    return request({
        url: "/api/team/dissolve",
        method: "post",
        data,
    });
}

// 成员列表 /api/team/memberList?teamId=1
export function teamMemberList(data) {
    return request({
        url: "/api/team/memberList",
        method: "post",
        data,
    });
}

// 添加成员 /api/team/batchBindMembers?teamId=1&userIds='1,2'
export function teamBatchBindMembers(data) {
    return request({
        url: "/api/team/batchBindMembers",
        method: "post",
        data,
    });
}

// 移除成员 /api/team/removeMember?teamId=1&targetUserId=1 
export function teamRemoveMember(data) {
    return request({
        url: "/api/team/removeMember",
        method: "post",
        data,
    });
}

// 修改成员角色 /api/team/updateMemberRole?teamId=1&targetUserId=1&role=1
export function teamUpdateMemberRole(data) {
    return request({
        url: "/api/team/updateMemberRole",
        method: "post",
        data,
    });
}

//  项目日志 projectId=1
export function teamProjectLogList(data) {
    return request({
        url: "/api/team/projectLogList",
        method: "post",
        data,
    });
}
// 项目概括接口
export function teamProjectOverview(data) {
    return request({
        url: "/api/team/projectOverview",
        method: "post",
        data,
    });
}
// 存储空间
export function teamMyStorage(data) {
    return request({
        url: "/api/team/myStorage",
        method: "post",
        data,
    });
}

// 资源图片接口  resourceId   resourceType 0 主体
export function ainewResourceImageList(data) {
    return request({
        url: "/api/team/imageByResource",
        method: "post",
        data,
    });
}

// 资源图片 选中  id=1&isSelected=1

export function selectImage(data) {
    return request({
        url: "/api/team/selectImage",
        method: "post",
        data,
    });
}

// 资源图片 删除  id
export function deleteImage(data) {
    return request({
        url: "/api/team/deleteImage",
        method: "post",
        data,
    });
}

// 质谱ai 识别文件内容
export function aizhipufile(data) {
    return request({
        url: "/api/aizhipufile",
        method: "post",
        data,
    });
}

// 新增画布项目
export function canvasProjectAdd(data) {
    return request({
        url: "/api/canvasProjectAdd",
        method: "post",
        data,
    });
}
// 查询画布项目
export function canvasProjectList(data) {
    return request({
        url: "/api/canvasProjectList",
        method: "post",
        data,
    });
}
//查询画布项目详情
export function canvasProjectDetail(data) {
    return request({
        url: "/api/canvasProjectDetail",
        method: "post",
        data,
    });
}
//修改画布项目详情
export function canvasProjectUpdate(data) {
    return request({
        url: "/api/canvasProjectUpdate",
        method: "post",
        data,
    });
}

// 删除画布项目
export function canvasProjectRemove(data) {
    return request({
        url: "/api/canvasProjectRemove",
        method: "post",
        data,
    });
}
// 新增 画布列表 
export function canvasAdd(data) {
    return request({
        url: "/api/canvasAdd",
        method: "post",
        data,
    });
}
//查询 画布列表  
export function canvasList(data) {
    return request({
        url: "/api/canvasList",
        method: "post",
        data,
    });
}
// 修改 画布详情
export function canvasUpdate(data) {
    return request({
        url: "/api/canvasUpdate",
        method: "post",
        data,
    });
}
//查询 画布详情 
export function canvasDetail(data) {
    return request({
        url: "/api/canvasDetail",
        method: "post",
        data,
    });
}
// 删除画布
export function canvasRemove(data) {
    return request({
        url: "/api/canvasRemove",
        method: "post",
        data,
    });
}
// 新增节点
export function canvasNodesadd(data) {
    return request({
        url: "/api/canvasNodesadd",
        method: "post",
        data,
    });
}
//修改单个节点
export function canvasNodeUpdate(data) {
    return request({
        url: "/api/canvasNodeUpdate",
        method: "post",
        data,
    });
}
//查询节点 
export function canvasNodeList(data) {
    return request({
        url: "/api/canvasNodeList",
        method: "post",
        data,
    });
}
// 删除节点
export function canvasNodeDelete(data) {
    return request({
        url: "/api/canvasNodeDelete",
        method: "post",
        data,
    });
}

// 查询连线
export function canvasEdgeList(data) {
    return request({
        url: "/api/canvasEdgeList",
        method: "post",
        data,
    });
}
// 新增连线
export function canvasEdgesadd(data) {
    return request({
        url: "/api/canvasEdgesadd",
        method: "post",
        data,
    });
}
// 删除连线
export function canvasEdgeDelete(data) {
    return request({
        url: "/api/canvasEdgeDelete",
        method: "post",
        data,
    });
}

// 获取画布模型列表
export function canvasAiModelList(data) {
    return request({
        url: "/api/canvasAiModelList",
        method: "post",
        data,
    });
}

// 节点文本生成  同步
export function canvasNodeAiText(data) {
    return request({
        url: "/api/canvasNodeAiText",
        method: "post",
        data,
    });
}

// 节点图片生成  异步
export function canvasNodeAiImage(data) {
    return request({
        url: "/api/canvasNodeAiImage",
        method: "post",
        data,
    });
}
// 节点视频生成  异步
export function canvasNodeAiVideo(data) {
    return request({
        url: "/api/canvasNodeAiVideo",
        method: "post",
        data,
    });
}
//  新增 AI 任务记录
export function canvasNodeAiTaskAdd(data) {
    return request({
        url: "/api/canvasNodeAiTaskAdd",
        method: "post",
        data,
    });
}
// 查询发单列表
export function jdorderList(data) {
    return request({
        url: "/api/jd/orderList",
        method: "post",
        data,
    });
}
// 新增发单
export function jdorderAdd(data) {
    return request({
        url: "/api/jd/orderAdd",
        method: "post",
        data,
    });
}
// 发单 分类
export function daServerCategorylist(data) {
    return request({
        url: "/api/daServerCategorylist",
        method: "post",
        data,
    });
}
// 查询发单详情 
export function jdorderInfo(data) {
    return request({
        url: "/api/jd/orderInfo",
        method: "post",
        data,
    });
}

// 新增留言
export function jdcommentAdd(data) {
    return request({
        url: "/api/jd/commentAdd",
        method: "post",
        data,
    });
}
// 查询留言 
export function jdcommentList(data) {
    return request({
        url: "/api/jd/commentList",
        method: "post",
        data,
    });
}
//删除留言
export function jdcommentRemove(data) {
    return request({
        url: "/api/jd/commentRemove",
        method: "post",
        data,
    });
}

// 报名详情
export function jdsignInfo(data) {
    return request({
        url: "/api/jd/signInfo",
        method: "post",
        data,
    });
}
// 修改报名 
export function jdsignEdit(data) {
    return request({
        url: "/api/jd/signEdit",
        method: "post",
        data,
    });
}

//新增报名 
export function jdsignAdd(data) {
    return request({
        url: "/api/jd/signAdd",
        method: "post",
        data,
    });
}

// 查询报名列表
export function jdsignList(data) {
    return request({
        url: "/api/jd/signList",
        method: "post",
        data,
    });
}
// 社区分类
export function communityList(data) {
    return request({
        url: "/api/ainew/community/communityList",
        method: "post",
        data,
    });
}
// 社区关注
export function communityFollow(data) {
    return request({
        url: "/api/ainew/community/communityFollow",
        method: "post",
        data,
    });
}
// 社区取消关注 
export function communityUnfollow(data) {
    return request({
        url: "/api/ainew/community/communityUnfollow",
        method: "post",
        data,
    });
}
// 标签查询
export function tagList(data) {
    return request({
        url: "/api/ainew/community/tagList",
        method: "post",
        data,
    });
}
//  今日优秀活动  
export function dailyTopActivity(data) {
    return request({
        url: "/api/ainew/activity/dailyTopActivity",
        method: "post",
        data,
    });
}
// 全部活动列表  
export function activityList(data) {
    return request({
        url: "/api/ainew/activity/activityList",
        method: "post",
        data,
    });
}

// 活动详情 
export function activityInfo(data) {
    return request({
        url: "/api/ainew/activity/activityInfo",
        method: "post",
        data,
    });
}

//  发帖 
export function postAdd(data) {
    return request({
        url: "/api/ainew/post/postAdd",
        method: "post",
        data,
    });
}
// 帖子列表
export function postList(data) {
    return request({
        url: "/api/ainew/post/postList",
        method: "post",
        data,
    });
}

// 帖子详情  
export function postInfo(data) {
    return request({
        url: "/api/ainew/post/postInfo",
        method: "post",
        data,
    });
}
//  帖子点赞 
export function postLike(data) {
    return request({
        url: "/api/ainew/post/postLike",
        method: "post",
        data,
    });
}
// 帖子删除 
export function postRemove(data) {
    return request({
        url: "/api/ainew/post/postRemove",
        method: "post",
        data,
    });
}
// 帖子举报 
export function postReport(data) {
    return request({
        url: "/api/ainew/post/postReport",
        method: "post",
        data,
    });
}
// 评论列表 
export function commentList(data) {
    return request({
        url: "/api/ainew/post/commentList",
        method: "post",
        data,
    });
}
// 评论删除
export function commentRemove(data) {
    return request({
        url: "/api/ainew/post/commentRemove",
        method: "post",
        data,
    });
}
// 新增评论 
export function commentAdd(data) {
    return request({
        url: "/api/ainew/post/commentAdd",
        method: "post",
        data,
    });
}
// 评论点赞
export function commentLike(data) {
    return request({
        url: "/api/ainew/post/commentLike",
        method: "post",
        data,
    });
}